import * as React from 'react';
import { useState } from 'react';
import {Modal, PrimaryButton, SpecialButton} from '@liveoptics/react-ui';
import styled from '@emotion/styled';
import '../css/modal-helpers.css';
import CloudCalcBaseModal from './CloudCalcBaseModal';

const ModalInnerWrap = styled.div`
    padding: 2rem;
`;

const ModalActionWrap = styled.div`
    display: flex;
    justify-content: flex-end;
    align-items: baseline;
`;

const GenericModal = ({modalTitle, modalText, cssClassName, closeFunction}) => {
    
    return (
        <CloudCalcBaseModal modalTitle={modalTitle} closeFn={closeFunction}>
            <ModalInnerWrap>
                <div>
                    {modalText}
                </div>
                <hr className='generic-modal-hr' />
                <ModalActionWrap>
                    <button className={cssClassName} onClick={closeFunction}>OK</button>
                </ModalActionWrap>
            </ModalInnerWrap>
        </CloudCalcBaseModal>
    );
}

export default GenericModal;